module.exports = __webpack_public_path__ + "img/final-img-mobile.32d3af78.jpg";